export const DESKTOP_PADDING_HORIZONTAL = 40;
export const MOBILE_PADDING_HORIZONTAL = 24;
export const PADDING_VERTICAL = 16;
